import { useAuth } from '../../context/AuthContext'
import { NotificationsList } from '../../components/NotificationsList'
import { PageHeader } from '../../components/ui/PageHeader'
import { PageShell } from '../../components/ui/PageShell'

export function NotificationsPage() {
  const { user } = useAuth()

  if (!user?.id) {
    return (
      <PageShell>
        <PageHeader title="Уведомления" lead="Войдите в систему, чтобы просмотреть уведомления." />
      </PageShell>
    )
  }

  return (
    <PageShell>
      <PageHeader
        title="Уведомления"
        lead="Системные сообщения: просрочки, дефицит сырья, простои и другие события."
      />
      <NotificationsList recipientId={user.id} limit={100} />
    </PageShell>
  )
}
